require('intersection-observer')

import appUtils from './app_utils'
import utils from './utils'

let targets
const toggleObserverOptions = {
 rootMargin: '0px',
 threshold: [0, 0.5, 1]
}

const body = document.querySelector('body')
const toggleObserverCallback = (entries, toggleObserver) => {
  entries.forEach(entry => {
    //if (entry.intersectionRatio < 0.2) {
    if (entry.isIntersecting) {
      if(entry.target.dataset.toggleclass) {
       body.classList.add(entry.target.dataset.toggleclass)
      }

      // if (entry.intersectionRatio > 0.4) {
      //   const eventName = entry.target.getAttribute('data-toggleclass-event')
      //   if (eventName) {
      //     appUtils.triggerEvent(eventName, entry)
      //   }
      // }

      entry.target.classList.add("in-view")
    } else {
      if(entry.target.dataset.toggleclass) {
       body.classList.remove(entry.target.dataset.toggleclass)
      }
      entry.target.classList.remove("in-view")
    }
  });
};

// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect
const toggleObserver = new IntersectionObserver(toggleObserverCallback, toggleObserverOptions);

const init = function() {
  targets = document.querySelectorAll("[data-toggleclass]")
  if (targets.length) {
    targets.forEach(target => toggleObserver.observe(target))
  }
}

const destroy = function() {
  if (targets.length) {
    targets.forEach((target) => {
      toggleObserver.unobserve(target)
      if(target.dataset.toggleclass) {
        body.classList.remove(target.dataset.toggleclass)
      }
    });
  }
}

export default {init, destroy}
